import { ChartOptions, TooltipItem } from 'chart.js'

/**
 * Common chart configuration factory for skill set charts
 */
export const createSkillSetChartOptions = (
  includeInteraction = false
): ChartOptions<'bar'> => ({
  responsive: true,
  plugins: {
    legend: { display: false },
    datalabels: {
      color: 'black',
      formatter: (value: string) => {
        return `${value || 0}%\n` // patch:bottom margin not applicable so added with lines
      },
      font: {
        size: 14,
        weight: 700
      },
      anchor: 'end'
    },
    tooltip: {
      borderColor: '#D2D2D2',
      borderWidth: 1,
      displayColors: false,
      callbacks: {
        label: (context: TooltipItem<'bar'>) => {
          const label = typeof context.raw === 'number' ? context.raw : 0
          return ` ${label} %`
        },
        title: () => {
          return ''
        }
      },
      bodyAlign: 'center',
      backgroundColor: 'white',
      titleColor: 'black',
      bodyColor: 'black',
      bodyFont: {
        size: 14,
        weight: 700
      }
    }
  },
  maintainAspectRatio: false,
  layout: { autoPadding: true, padding: { top: 20 } },
  scales: {
    x: {
      ticks: {
        font: {
          size: 14,
          weight: 700
        }
      }
    },
    y: {
      min: 0,
      max: 100,
      ticks: {
        stepSize: 20, // Adjust step size to ensure 10, 50, and 100 are displayed
        callback: (value: number | string) => `${value} %`
      }
    }
  },
  ...(includeInteraction && {
    interaction: {
      intersect: false,
      mode: 'nearest',
      axis: 'x'
    }
  })
})

/**
 * Common dataset configuration for bar charts
 */
export const createBarDatasetConfig = (backgroundColor: string) => ({
  backgroundColor,
  borderRadius: 6,
  borderSkipped: false
})
